export default [
    {
        path: '/emcadmin/plans/modules',
        name: 'emcadmin-modules',
        component: () => import ('./views/ModuleIndex'),
        meta: {
            title: 'Módulos do Sysclass',
            icon: 'mdi-layers-triple',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
